<template>
  <div class="zpa-form-group" :class="classes" :inline="inline">
    <div class="legend title" v-if="title">{{title}}</div>

    <div class="zpa-row wrap start top">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {
  findUpProperty,
} from '../utils'
import props from './form-props'

export default {
  name: 'zpaFormGroup',
  data() {
    return {
      wrap: true,
      groups: [],
      fields: [],
      level: 0,
      entry: null,
    }
  },

  props: {
    title: String,

    inline: Boolean,

    dynamics: Boolean,

    childTable: Boolean,

    canAdd: Boolean,

    ...props,
  },

  computed: {
    $size() {
      return findUpProperty(this, 'size', 'default')
    },

    classes() {
      return [this.$size]
    },
  },

  inject: ['form', 'group'],

  provide() {
    return {
      group: this,
    }
  },

  methods: {
    flexDirection() {
      return 'row'
    },

    setEntry(entry) {
      if (!entry || entry.target !== this.$el) return
      this.entry = entry
    },
  },

  created() {
    if (!this.form) return
    if (this.group) {
      this.level = this.group.level + 1
    }
    if (this.group) {
      this.form.addGroup(this, this.group)
    }
  },

  beforeDestroy() {
    if (!this.form) return

    this.form.removeGroup(this, this.group)
  },
}
</script>

<style scoped lang="less">
.zpa-form-group {
  border: none;
  margin: 7px 0;
  width: 100%;

  padding-left: 8px;
  padding-right: 4px;
  /*background: #0f03;*/
  /*border: 1px solid #ddd7;*/
  /*min-height: 100px;*/

  &.small {
    & > .legend {
      font-size: 12px;
    }

    margin: 4px 0;
  }

  .legend {
    width: 100%;
    text-align: left;
    font-size: 14px;
    font-weight: 700;
    border-bottom: 1px solid #ccc;
    margin-bottom: 4px;
  }
  .btnContent {
    width: 100%;
    overflow: hidden;
    vertical-align: middle;
  }
  .btn_remove {
    float: right;
    margin-right: 5px;
  }
  .btn_add {
    float: right;
  }
}
</style>
